module.exports = __webpack_public_path__ + "static/media/RobotoBold.b8e42971.ttf";